// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__37JWL","noInteraction":"EventWrapper_noInteraction__vciVI","pointerPassthrough":"EventWrapper_pointerPassthrough__SPNd8"};